import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import CustomExternalAnchor from '../../customExternalAnchor';
import RoutableSitecoreLink from '../../routableSitecoreLink';
import { TLinkWithField } from '../types/cta.types';
import HasChildrenOrIcon from './hasChildrenOrIcon';
import ValidHrefAndNotEditing from './validHrefAndNotEditing';

const LinkWithField: FC<TLinkWithField> = (props) => {
  const { field, hasCTAIcon, ctaClassName, target, children, isSecondaryCTA, iconField, iconName, onClick } = props;

  const hasValidHref = field.value && field.value.href;
  /* eslint-disable-next-line */
  const isEditing = (field as unknown as { editable: any }).editable;

  // only want to apply the routing link if not editing (if editing, need to render editable link value)
  if (hasValidHref && !isEditing) {
    return (
      <ValidHrefAndNotEditing
        field={field}
        target={target}
        ctaClassName={ctaClassName}
        hasCTAIcon={hasCTAIcon}
        isSecondaryCTA={isSecondaryCTA}
        iconField={iconField}
        iconName={iconName}
        onClick={onClick}
      >
        {children}
      </ValidHrefAndNotEditing>
    );
  }

  if (children || hasCTAIcon) {
    return (
      <HasChildrenOrIcon
        target={target}
        isSecondaryCTA={isSecondaryCTA}
        iconField={iconField}
        iconName={iconName}
        field={field}
        ctaClassName={ctaClassName}
        hasCTAIcon={hasCTAIcon}
        isEditing={isEditing}
      >
        {children}
      </HasChildrenOrIcon>
    );
  }

  if (!hasCTAIcon) {
    // Primary CTA with no children
    return (
      <span className={ctaClassName}>
        <CustomExternalAnchor field={field} />
      </span>
    );
  }

  return <RoutableSitecoreLink field={field} onClick={onClick} className={ctaClassName} editable={isEditorActive()} />;
};

export default LinkWithField;
